import React from "react";
import { HorizontalStoryCard } from "../../basic/horizontal-story-card";
import { ReadMoreBtn } from "../../atoms/read-more-btn";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import "./styles.m.css";

function MostPopularBase({
  mostPopular,
  syleName = "",
  id = "",
  titleRequired = true,
  publisherAttributes = {},
  collectionName,
  collectionSlug,
  collectionTemplate,
  readMoreText
}) {
  const getMostPopularTitle = () => {
    if (publisherAttributes.lang === "en") {
      return "Most Popular";
    } else if (publisherAttributes.lang === "hi") {
      return "लोकप्रिय";
    } else {
      return "پسندیدہ ترین";
    }
  };

  const collectionNameStyle = collectionName ? "collection-heading" : "heading";

  return !mostPopular.length ? null : (
    <div>
      {titleRequired && <div styleName="heading">{getMostPopularTitle()}</div>}
      {collectionName && <h2 styleName={`${collectionNameStyle}`}>{collectionName}</h2>}
      {mostPopular.filter(story => story.id !== id).map((story, index) => (
        <div key={index}>
          <HorizontalStoryCard story={story} imageAspectRatio="1,1" cardSize="small" hideIcon />
        </div>
      ))}
      <ReadMoreBtn
        collectionTemplate={collectionTemplate}
        collectionSlug={collectionSlug}
        readMoreText={readMoreText}
      />
    </div>
  );
}

MostPopularBase.propTypes = {
  story: PropTypes.object,
  id: PropTypes.string,
  mostPopular: PropTypes.Array,
  titleRequired: PropTypes.boolean,
  publisherAttributes: PropTypes.object,
  syleName: PropTypes.string,
  collectionName: PropTypes.string,
  collectionSlug: PropTypes.string,
  collectionTemplate: PropTypes.string,
  readMoreText: PropTypes.string
};

function mapStateToProps(state) {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"])
  };
}

export const MostPopular = connect(
  mapStateToProps,
  null
)(MostPopularBase);
